import { FormControl, Validators } from '@angular/forms';
import {
  EoFormPanelConfig,
  EoInputConfig,
} from 'ngx-eo-web-components';

const userPasswordValidators = new FormControl(null, [
  Validators.required,
  Validators.minLength(8),
  Validators.pattern(/[!@#$%^&*]/),
  Validators.pattern(/\d/),
  Validators.pattern(/[a-zA-Z]/)
]);
const newUserPasswordValidators = new FormControl(null, [
  Validators.required,
  Validators.minLength(8),
  Validators.pattern(/[!@#$%^&*]/),
  Validators.pattern(/\d/),
  Validators.pattern(/[a-zA-Z]/)
]);
const confirmNewUserPasswordValidators = new FormControl(null, [
  Validators.required
]);

export const newUserPasswordFormPanel = new EoFormPanelConfig({
  name: 'newUserPasswordForm',
  panelContentStyleClass: 'grid',
  config: [
    new EoInputConfig({
      name: 'oldPassword',
      styleClass: 'w-full mb-3',
      type: 'password',
      label: 'Τρέχων Κωδικός',
      control: userPasswordValidators,
      placeholder: 'Παρακαλώ συμπληρώστε τον τρέχοντα κωδικό',
      errors: {
        // pattern: 'Ο κωδικός πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες, έναν αριθμό, ένα γράμμα και ένα ειδικό χαρακτήρα.'
      }

    }),
    new EoInputConfig({
      name: 'password',
      styleClass: 'w-full mb-3',
      type: 'password',
      label: 'Νέος Κωδικός',
      control: newUserPasswordValidators,
      placeholder: 'Παρακαλώ συμπληρώστε τον νέο κωδικό',
      errors: {
        // pattern: 'Ο κωδικός πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες, έναν αριθμό, ένα γράμμα και ένα ειδικό χαρακτήρα.',
        passwordMismatch: 'Οι κωδικοί δεν ταιριάζουν'
      }
    }),
    new EoInputConfig({
      name: 'repeatPassword',
      styleClass: 'w-full ',
      type: 'password',
      label: 'Επαναλάβετε τον νέο κωδικό',
      control: confirmNewUserPasswordValidators,
      placeholder: 'Παρακαλώ επαναλάβετε τον νέο κωδικό',
      errors: {
        // pattern: 'Ο κωδικός πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες, έναν αριθμό, ένα γράμμα και ένα ειδικό χαρακτήρα.',
        passwordMismatch: 'Οι κωδικοί δεν ταιριάζουν'
      }
    }),
  ]
});

export const newUserPasswordFormConfig: EoFormPanelConfig[] = [newUserPasswordFormPanel];
